import React, { FC } from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';

export type TextBoxProps = TextFieldProps;

export const TextBox: FC<TextBoxProps> = (props) => {
  return <TextField fullWidth {...props} />;
};
